import { render, staticRenderFns } from "./SystemRecordsManageForm.vue?vue&type=template&id=53f5f05d&scoped=true&"
import script from "./SystemRecordsManageForm.vue?vue&type=script&lang=js&"
export * from "./SystemRecordsManageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5f05d",
  null
  
)

export default component.exports